import HttpRequest from "@/libs/HttpRequest";

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);
// const axios = new HttpRequest('/api');


export default axios;
